export const loop = {
  input: {
    elements: "Zu iterierende Elemente"
  },
  output: {
    element: "Iterations Element",
    key: "Iterations Schlüssel"
  }
};
